import { useLanguage } from "@/context/AppContext";

export default function Ventures() {
  const { t } = useLanguage();
  return (
    <section id="ventures" className="section ventures" data-testid="ventures-section">
      <div className="section-label">{t.ventures.label}</div>
      <div className="ventures-head">
        <h2 data-testid="ventures-section-title">
          {t.ventures.l1}
          <br />
          <em>{t.ventures.l2}</em>
        </h2>
        <p>{t.ventures.p}</p>
      </div>
      <div className="cards">
        {t.ventures.items.map((v, i) => (
          <article className={`card ${i === 1 ? "featured" : ""}`} key={v.key} data-testid={`venture-card-${v.key}`}>
            <div className="card-number">{String(i + 1).padStart(2, "0")}</div>
            <div className="icon">{v.icon}</div>
            <h3>{v.title}</h3>
            <p>{v.desc}</p>
            <a href="#contact" data-testid={`venture-explore-${v.key}`}>
              {t.ventures.explore}
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
